import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GeneraRutasService } from '../../servicios/genera-rutas.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MuestraMensaje } from '../../shared/utilerias/notificaciones/notificaciones.component';
import {
    GeneraRutas, CatRutas, GeneraRutasInput, CatUsuarios
    , ObtenerUsuarioPorCargo, ObtenerUsuarioPorCargoInput,
    ConsultaLecturasInput, AsignaLecturistasInput, AsignaLecturistas, AuxJasper,
    ParametroJasper, BuscaAsignacionesInput, EditaLecturistaInput,
    cuentas
} from '../../entidades/entidades';
import { CatRutasService } from '../../servicios/cat-rutas.service';
import { CatUsuariosService } from 'app/servicios/cat-usuarios.service';
import { BuscaLecturistaService } from '../../servicios/busca-lecturista.service';
import { ObtenerUsuarioPorCargoService } from 'app/servicios/obtener-usuario-por-cargo.service';
import { AsignaLecturistasService } from 'app/servicios/asigna-lecturistas.service';
import { EditaLecturistaService } from '../../servicios/edita-lecturista.service';
import { JasperService } from 'app/servicios/jasper.service';
import { BuscaAsignacionesService } from 'app/servicios/busca-asignaciones.service';
import { BuscaAsignaciones, BuscaLecturistaInput, BuscaLecturista } from '../../entidades/entidades';
import { ConsultaLecturasComponent } from '../consulta-lecturas/consulta-lecturas.component';
import { SelectItem } from 'primeng/api';

declare var $: any;
@Component({
    selector: 'app-genera-rutas',
    templateUrl: './genera-rutas.component.html',
    styleUrls: ['./genera-rutas.component.css']
})

export class GeneraRutasComponent implements OnInit {
    muestraMensaje = new MuestraMensaje();
    generaRutasForm: FormGroup;
    // tslint:disable-next-line: no-input-rename
    @Input('generaRutas') generaRutas: GeneraRutasInput;
    // tslint:disable-next-line: no-output-rename
    @Output('generaRutasOutput') generaRutasOutput: EventEmitter<GeneraRutas>;
    // tslint:disable-next-line: no-input-rename
    @Input('catUsuarios') catUsuarios: CatUsuarios;
    // tslint:disable-next-line: no-input-rename
    @Input('obtenerUsuarioPorCargo') obtenerUsuarioPorCargo: ObtenerUsuarioPorCargo;
    // tslint:disable-next-line: no-output-rename
    @Output('obtenerUsuarioPorCargoOutput') obtenerUsuarioPorCargoOutput: EventEmitter<ObtenerUsuarioPorCargo>;

    public jasperInputExporta$ = new EventEmitter<AuxJasper>();
    public jasperInput$ = new EventEmitter<AuxJasper>();

    @Input("consultaLecturasInput") consultaLecturasInput: ConsultaLecturasInput;

    public usuarioPorCargo = new ObtenerUsuarioPorCargoInput();
    public generaRutasI = new GeneraRutasInput();
    public usuariosLect = new CatUsuarios();
    public asignaLecturistas = new AsignaLecturistasInput();
    public bimestres: any[] = [];
    public catRutas: CatRutas[] = [];
    public catUsuaios: CatUsuarios[] = [];
    public buscaLecturistaInput: BuscaLecturistaInput;
    public buscaLecturista: BuscaLecturista;
    public editaLecturistaInput: EditaLecturistaInput;
    public id_consumo: number;
    public id_consumos: string;
    public id_lecturista: number;
    public id_lecturistas: string;
    public cuentas : cuentas [];
    public cuenta : cuentas;

    // -----------------------------------------------------

    cols: any[] = [];
    public resumenD: AsignaLecturistas[] = [];
    public resumenI: BuscaAsignaciones[] = [];
    public combos: ConsultaLecturasInput[] = [];

    // ------------------------------------------------------
    public ruta: CatRutas;
    public bimestre;
    public anio: any;
    public rutas: any;
    public usuarioCapturistaD: ObtenerUsuarioPorCargo[] = [];
    public usuarioCapturistaS: ObtenerUsuarioPorCargo[] = [];
    public direcciones: any;
    public id_usuario_asigna: any;
    public auxJasper: AuxJasper;
    private _jasperService: JasperService;
    public verPicklist = false;
    public verTablaI = false;
    public verTablaD = false;
    public progressBar = false;
    columnasTabla: any[];
    generaRutasTable: GeneraRutas[];
    selectedAll: boolean = false;
    usuariosCaptura: SelectItem[];
    selectUsuarioCaptura : number;
    consecutivoIni: number = null;  // Inicio del rango
    consecutivoFin: number = null; 
    filteredRutasTable: GeneraRutas[] = [];



    showBar() {
        this.progressBar = true;
    }

    public buscaAsignacionesI = new BuscaAsignacionesInput();

    display: boolean = false;
    displayModifica: boolean = false;
    showDialog() {
        this.display = true;
    }

    showDialogModifica() {
        this.displayModifica = true;
    }

    constructor(
        private formBuilder: FormBuilder,
        private generaRutasService: GeneraRutasService,
        private route: ActivatedRoute,
        private catRutasService: CatRutasService,
        private catUsuariosService: CatUsuariosService,
        private BuscaLecturistaService: BuscaLecturistaService,
        private EditaLecturistaService: EditaLecturistaService,
        private obtenerUsuarioPorCargoService: ObtenerUsuarioPorCargoService,
        private asignaLecturistasService: AsignaLecturistasService,
        private buscaAsignacionesService: BuscaAsignacionesService,
        private jasp: JasperService,
        private router: Router
    ) {
        this.generaRutasOutput = new EventEmitter(),
            this.id_usuario_asigna = JSON.parse(localStorage.getItem('currentUser'));
    }

    ngOnInit() {
        const fecha = new Date();
        this.anio = fecha.getFullYear();
        this.generaRutasForm = this.formBuilder.group({
            anioIn: [undefined],
            ruta: [undefined],
            bimestre: [undefined],
            direcciones: [undefined],
        });
        if (this.generaRutas) { this.generaRutasForm.patchValue(this.generaRutas); }

        this.cols = [
            { field: 'lecturista', header: 'Lecturista' },
            { field: 'cuentas', header: 'N° Cuentas' },
            { field: 'fechaAsignacion', header: 'Fecha de Asignacion' }
        ];
        this.columnasTabla = [
            // { field: "operacion",header: "", ordenar: false, style: "width: 100px;"},
            { field: "cuentaAgua", header: "Cuenta Agua",ordenar: true, style: "width: 100px;",},
            { field: "consecutivo", header: "Consecutivo",ordenar: true, style: "width: 100px;",},
            { field: "colonia", header: "Colonia",ordenar: true, style: "width: 450px;",},
            { field: "tipoUso", header: "Tipo Uso",ordenar: true, style: "width: 300px;",},
            { field: "nombreLocal", header: "Nombre Local",ordenar: true, style: "width: 450px;",}, 
          ];
        this.addObtenerUsuarioPorCargo();
    }

    // ====================================================
    // Metodo para Obtener los Usuarios Lecturistas
    // ====================================================
    async addObtenerUsuarioPorCargo() {
        try {
            this.usuarioPorCargo.idCargo = 1; // Lecturista 
            this.usuarioPorCargo.idEstatus = 1; // Vigente 
            const datoretorno = await this.obtenerUsuarioPorCargoService
                .add(this.usuarioPorCargo)
                .toPromise();
            this.obtenerUsuarioPorCargo = datoretorno;
            this.usuarioCapturistaD.push(datoretorno);
            console.log('Usuarios Capturista', this.usuarioCapturistaD);
            this.usuariosCaptura = this.obtenerUsuarioPorCargo.map((datos) => {
                return { label: datos.nombre, value: datos.id };
            });
            this.usuariosCaptura.unshift({ label: "Seleccione un lecturista",value: null});
            // this.obtenerUsuarioPorCargoForm.patchValue(this.obtenerUsuarioPorCargo);
        } catch (e) {
            if (e.response) { throw { message: e.response.data }; } else { throw e; }
        } finally {
            console.log('Paso por addObtenerUsuarioPorCargo');
        }
    }

    // ====================================================
    // Metodo Para Generar Rutas 
    // (Busca las rutas no asignadas)*
    // ====================================================
    async childBusquedaLectura(buscaLectura: ConsultaLecturasInput) {
        console.log('Lectura: ', buscaLectura);
        await this.combos.splice(0);
        try {
            await this.combos.push(buscaLectura);
            console.log('this.combos', this.combos);
            this.generaRutasI.periodo = buscaLectura.periodo;
            this.asignaLecturistas.periodoParcialidad = buscaLectura.periodo;
            this.generaRutasI.zona = buscaLectura.ruta;
            this.asignaLecturistas.idAguaZona = buscaLectura.ruta;
            this.generaRutasI.anioIn = buscaLectura.anioIn;
            this.asignaLecturistas.anio = buscaLectura.anioIn;
            this.generaRutasI.idColonia = buscaLectura.colonia;
            this.asignaLecturistas.idColonia = buscaLectura.colonia;

            this.buscaAsignacionesI.anio = buscaLectura.anioIn;
            this.buscaAsignacionesI.idAguaZona = buscaLectura.ruta;
            this.buscaAsignacionesI.periodoParcialidad = buscaLectura.periodo;
            this.buscaAsignacionesI.idUsuarioLecturista = buscaLectura.lecturista;
            this.buscaAsignacionesI.idColonia = buscaLectura.colonia;
            if (this.generaRutasI.zona != null) {
                if (this.generaRutasI.anioIn != null) {
                    if (this.generaRutasI.periodo != null) {
                        this.showBar();

                        console.log("this.generaRutasI", this.generaRutasI);
                        await this.addGeneraRutas(this.generaRutasI);
                    } else {
                        throw new Error("Debe seleccionar un Bimestre.");
                    }
                } else {
                    throw new Error("Debe seleccionar una Año.");
                }
            } else {
                throw new Error("Debe seleccionar una Ruta.");
            }

        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
        } finally {
            console.log("Paso por getLecturas");
        }
    }

    // ====================================================
    // Metodos para obtener el N° de Cuentas
    // ====================================================
    async addGeneraRutas(generaRutas) {
        try {
            const datoretorno = await this.generaRutasService
                .add(generaRutas)
                .toPromise();
            this.generaRutasTable = datoretorno;
            this.filteredRutasTable = this.generaRutasTable ;
            console.log('N° RUTAS', datoretorno);
           // this.direcciones = datoretorno[0].direcciones;
            if (datoretorno) {

            }
            if (datoretorno.length > 0) {
                this.verPicklist = true;
                this.progressBar = false;
                this.generaRutasForm.patchValue({
                    direcciones: 'La combinación seleccionada contiene ' + datoretorno.length + ' Cuentas'
                });
                
            } else {
                this.verPicklist = false;
                this.verTablaD = false;
                this.verTablaI = true;
                this.buscaAsignaciones();
                this.generaRutasForm.patchValue({
                    direcciones: 'Las Cuentas de la combinación seleccionada ya fueron asignadas'
                });
            }
          
            //this.generaRutasOutput.emit(datoretorno);
        } catch (e) {
            if (e.response) { throw { message: e.response.data }; } else { throw e; }
        } finally {
            console.log('Paso por addGeneraRutas');
        }
    }

    async UpdateLecturistaS() {
        try {
            this.id_consumos = "";
            this.id_lecturistas = "";
            await this.showBar();
            this.editaLecturistaInput = new EditaLecturistaInput();
            if (this.usuarioCapturistaS.length != 0) {
                this.id_lecturista = null;

                for (var i in this.usuarioCapturistaS) {
                    this.id_lecturista = this.usuarioCapturistaS[i].id;
                    this.id_lecturistas = this.id_lecturistas + this.id_lecturista.toString() + ",";
                }
                if (this.id_lecturistas.length > 0) {
                    this.id_lecturistas = this.id_lecturistas.substring(0, this.id_lecturistas.length - 1)
                }
            } else {
                this.progressBar = false;
                throw new Error("Debe seleccionar al menos un Lecturista.");
            }
            console.log('this.buscaLecturista:',this.buscaLecturista)

            if (this.buscaLecturista) {

                this.id_consumo = null;
                debugger;
                for (var i in this.buscaLecturista) {
                    console.log("i", i);
                    this.id_consumo = this.buscaLecturista[i].idConsumo;
                    this.id_consumos = this.id_consumos + this.id_consumo.toString() + ",";
                }
                if (this.id_consumos.length > 0) {
                    this.id_consumos = this.id_consumos.substring(0, this.id_consumos.length - 1)
                }
                this.editaLecturistaInput.idLecturistasIn = this.id_lecturistas;
                this.editaLecturistaInput.idConsumosIn = this.id_consumos;

                const datoRetorno = await this.EditaLecturistaService.updateLecturista(this.editaLecturistaInput).toPromise();
                console.log(datoRetorno);
                this.ActualizaBusqueda();

            }

        } catch (e) {
            this.displayModifica = false;
            if (e.response) throw { message: e.response.data };
            this.muestraMensaje.error(e.message, "top", "center");

        } finally {
            this.progressBar = false;
            this.displayModifica = false;
            console.log("Paso por UpdateLecturistaS");

        }
    }
    async ActualizaBusqueda() {
        try {
            console.log('this.combos', this.combos);

            var buscaLecturas = new ConsultaLecturasInput();
            buscaLecturas.ruta = this.combos[0].ruta;
            buscaLecturas.anioIn = this.combos[0].anioIn;
            buscaLecturas.periodo = this.combos[0].periodo;
            buscaLecturas.colonia = this.combos[0].colonia
            await this.childBusquedaLectura(buscaLecturas)
        } catch (e) {
            if (e.response) { throw { message: e.response.data }; } else { throw e; }
        } finally {
            console.log('Paso por ActualizaBusqueda');
        }

    }
    // ====================================================
    // Metodo Para Asignar Lecturistas
    // ====================================================
    async asignaLecturistaS() {
        try {
            console.log("contratos", this.generaRutasTable);
            debugger;
            if (this.selectUsuarioCaptura) {
                this.asignaLecturistas.idUsuarioLecturista = this.selectUsuarioCaptura ;
            } else {
                this.progressBar = false;
                throw new Error("Debe seleccionar al menos un Lecturista.");
            }
            this.showBar();
            this.cuentas =new Array<cuentas>();
            this.generaRutasTable.forEach(x=> {
                if(x.select){
                    this.cuenta = new cuentas();
                    this.cuenta.id = x.idAgua;
                    this.cuentas.push(this.cuenta);
                }
            });
            this.asignaLecturistas.jsonCuentas = this.cuentas;
            if (this.selectUsuarioCaptura != 0) {
                this.asignaLecturistas.idUsuarioLecturista = this.selectUsuarioCaptura ;
            } else {
                this.progressBar = false;
                throw new Error("Debe seleccionar al menos un Lecturista.");
            }

            this.asignaLecturistas.idUsuarioAsigno = this.id_usuario_asigna.id;
            console.log(this.asignaLecturistas, ', asigna: ', this.id_usuario_asigna.id);
            const datoretorno = await this.asignaLecturistasService
                .add(this.asignaLecturistas)
                .toPromise();
            if (datoretorno) {
                this.resumenD = [];
                this.resumenD.push(datoretorno);
                this.verPicklist = false;
                this.verTablaI = false;
                this.verTablaD = true;
                console.log(datoretorno);
                this.progressBar = false;
                this.consecutivoFin = null;
                this.consecutivoIni = null;
                this.selectedAll = false;
            }
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            this.muestraMensaje.error(e.message, "top", "center");
        } finally {
            this.progressBar = false;
            console.log("Paso por asignaLecturistaS");
        }
    }
    // cerr || 20240604 se agrega metodo para la seleccion del dropdown 
    async selectLecturista(lecturista){
        debugger;
        if(!lecturista.value) return;
        this.selectUsuarioCaptura = lecturista.value;
        console.log("GIRO: ", lecturista.value.id);
    }


    // ====================================================
    // Metodos para obtener las asignaciones
    // ====================================================
    async buscaAsignaciones() {
        try {
            console.log('  SE MANDA BUSCAR ESTO', this.buscaAsignacionesI)
            const datoretorno = await this.buscaAsignacionesService
                .add(this.buscaAsignacionesI)
                .toPromise();
            console.log('this.buscaAsignaciones =', datoretorno);
            this.resumenI = [];
            if (datoretorno)
                this.progressBar = false;
            this.resumenI.push(datoretorno);
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log("Paso por addBuscaAsignaciones");

        }
    }
    // ====================================================
    // Metodos para exportar Hoja Trabajo a Excel
    // ====================================================
    async exportaHojaTrabajo(nodo: AsignaLecturistas) {
        try {
            debugger;
            this.auxJasper = new AuxJasper();
            this.auxJasper.JasperReport.nombreReporte = '007_Hoja_trabajo_lecturista';
            this.auxJasper.JasperReport.tipo = "xlsx";
            // -- Parametros --
            const _id_agua_zona = new ParametroJasper();
            _id_agua_zona.nombre = '_id_agua_zona';
            _id_agua_zona.valor = this.combos[0].ruta + '';

            const _anio = new ParametroJasper();
            _anio.nombre = '_anio';
            _anio.valor = this.combos[0].anioIn + '';

            const _periodo_parcialidad = new ParametroJasper();
            _periodo_parcialidad.nombre = '_periodo_parcialidad';
            _periodo_parcialidad.valor = this.combos[0].periodo + '';

            const _id_usuario_lecturista = new ParametroJasper();
            _id_usuario_lecturista.nombre = '_id_usuario_lecturista';
            _id_usuario_lecturista.valor = nodo.idUsuario + '';

            //const _id_colonia = new ParametroJasper();
            //_id_colonia.nombre = '_id_colonia';
            //_id_colonia.valor = this.combos[0].colonia.toString();


            await this.auxJasper.ParametroJasper.push(_id_agua_zona);
            await this.auxJasper.ParametroJasper.push(_anio);
            await this.auxJasper.ParametroJasper.push(_periodo_parcialidad);
            await this.auxJasper.ParametroJasper.push(_id_usuario_lecturista);
            //await this.auxJasper.ParametroJasper.push(_id_colonia);
            console.log('Agui va', this.auxJasper);
            // ---DESCARGA EXCEL
            this.jasperInput$.emit(this.auxJasper);

        } catch (e) {
            if (e.response) { throw { message: e.response.data }; } else { throw e; }
        } finally {
            console.log('Paso por exportaHojaTrabajo');
        }
    }
    async ModificarLecturista(nodo: AsignaLecturistas) {
        try {
            this.buscaLecturistaInput = new BuscaLecturistaInput();
            this.buscaLecturistaInput.anio = this.combos[0].anioIn;
            this.buscaLecturistaInput.periodoParcialidad = this.combos[0].periodo;
            this.buscaLecturistaInput.idAguaZona = this.combos[0].ruta;
            this.buscaLecturistaInput.idUsuarioLecturista = nodo.idUsuario;
            this.buscaLecturistaInput.idColonia = this.combos[0].colonia;
            console.log('this.buscaLecturistaInput', this.buscaLecturistaInput);

            if (this.buscaLecturistaInput) {
                const datoRetorno = await this.BuscaLecturistaService.getBusquedas(this.buscaLecturistaInput).toPromise();
                this.buscaLecturista = datoRetorno;
                console.log("this.buscaLecturista", this.buscaLecturista);
                if (this.buscaLecturista) {
                    this.showDialogModifica();
                }
            } else {
                throw new Error("No se pudo realizar la operación.");
            }
        } catch (e) {
            if (e.response) { throw { message: e.response.data }; } else { throw e; }
        } finally {
            console.log('Paso por ModificarLecturista');
        }
    }
    // ====================================================
    // Metodos para imprimir Hoja Trabajo 
    // ====================================================

    async imprimeHojaTrabajo(nodo: AsignaLecturistas) {
        this.muestraMensaje.notification(nodo.lecturista, "top", "center");
        try {
            this.auxJasper = new AuxJasper();
            this.auxJasper.JasperReport.nombreReporte = '007_Hoja_trabajo_lecturista';
            this.auxJasper.JasperReport.tipo = 'pdf';
            // -- Parametros --
            const _id_agua_zona = new ParametroJasper();
            _id_agua_zona.nombre = '_id_agua_zona';
            _id_agua_zona.valor = this.combos[0].ruta + '';

            const _anio = new ParametroJasper();
            _anio.nombre = '_anio';
            _anio.valor = this.combos[0].anioIn + '';
            console.log(this.combos[0].anioIn + '');

            const _periodo_parcialidad = new ParametroJasper();
            _periodo_parcialidad.nombre = '_periodo_parcialidad';
            _periodo_parcialidad.valor = this.combos[0].periodo + '';

            const _id_usuario_lecturista = new ParametroJasper();
            _id_usuario_lecturista.nombre = '_id_usuario_lecturista';
            _id_usuario_lecturista.valor = nodo.idUsuario + '';

            /*const _id_colonia = new ParametroJasper();
            _id_colonia.nombre = '_id_colonia';
           S_id_colonia.valor = this.combos[0]?.colonia?.toString() || '';*/

            await this.auxJasper.ParametroJasper.push(_id_agua_zona);
            await this.auxJasper.ParametroJasper.push(_anio);
            await this.auxJasper.ParametroJasper.push(_periodo_parcialidad);
            await this.auxJasper.ParametroJasper.push(_id_usuario_lecturista);
            /*await this.auxJasper.ParametroJasper.push(_id_colonia);*/

            console.log('Agui va', this.auxJasper);

            await this.jasperInputExporta$.emit(this.auxJasper);
            await this.showDialog();
        } catch (e) {
            if (e.response) { throw { message: e.response.data }; } else { throw e; }
        } finally {
            console.log('Paso por imprimeHojaTrabajo');
        }

    }
    // Cerr || 20240603 || se agrega para la funcionalidad de seleccion masiva
    async selectAll(e) {
        try {
            
            var isChecked = e.checked;
            this.filteredRutasTable.forEach(e=> {
                e.select = isChecked;
            })            
        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
            if (e.response) { throw { message: e.response.data }; } else { throw e; }
        } finally {
            console.log('Paso por selectAll');
        }
    }
    // cerr || 202406060 || se agrega metodo para filtro de cuentas
    async filterConsecutivos() {
        this.filteredRutasTable = this.generaRutasTable;
        if(!this.consecutivoIni) return;
        if(!this.consecutivoFin) return
        this.filteredRutasTable = this.generaRutasTable.filter(item => 
            item.consecutivo >= this.consecutivoIni && item.consecutivo <= this.consecutivoFin
        );
    }


}
